import { baseBuyer } from "@/utils/server/api";
import { Stripe, StripeCardElement } from "@stripe/stripe-js";
import axios from "axios";

interface CheckoutOptions {
  amount: number;
  cardElement: StripeCardElement;
  stripe: Stripe;
  property_id: number;
  quantity: number;
}

export function useStripeCheckout() {
  const token = localStorage.getItem("token");

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };

  const checkout = async ({
    amount,
    cardElement,
    stripe,
    property_id,
    quantity,
  }: CheckoutOptions) => {
    try {
      const result = await stripe.createPaymentMethod({
        type: "card",
        card: cardElement,
      });
      if (!result.paymentMethod) throw new Error("paymentMethod não gerado");

      const { data } = await axios.post(
        `${baseBuyer}/payment/create`,
        {
          payment_method: "card",
          payment_method_id: result.paymentMethod.id,
          amount,
          property_id,
          quantity,
        },
        config
      );

      console.log('====================================');
      console.log(data);
      console.log('====================================');

      alert("Pagamento realizado com sucesso");
      return data;
    } catch (error) {
      console.error("Erro no checkout:", error);
      alert("Falha ao realizar pagamento.");
    }
  };

  return { checkout };
}
